<template>
    <div>
        <ProfileBlock :title="$t('components.phones_edit.block_name')">
            <div class="divide-y">
                <!-- primary phone -->
                <div class="py-3" v-if="primary">
                    <div class="flex flex-row justify-between items-center">
                        <div class="flex-1 font-semibold">
                            {{ primary.number }}
                        </div>
                        <div class="text-orange flex items-center">
                            <span class="material-icons-outlined">star</span>
                        </div>
                    </div>
                </div>

                <!-- filtered_phones (non primary) -->
                <div
                    v-for="phone in filtered_phones"
                    :key="phone.id"
                    class="py-3"
                >
                    <div class="flex flex-row justify-between items-center">
                        <div class="flex-1">{{ phone.number }}</div>
                        <div
                            class="hover:text-red flex items-center"
                            @click="destroy({ id: phone.id })"
                        >
                            <!-- delete -->
                            <span class="material-icons-outlined mr-1"
                                >delete</span
                            >
                        </div>
                        <div
                            class="hover:text-orange flex items-center"
                            @click="
                                set_primary({ id: phone.id, is_primary: true })
                            "
                        >
                            <!-- make primary -->
                            <span class="material-icons-outlined">grade</span>
                        </div>
                    </div>
                </div>
            </div>
            <div></div>
            <!-- this empty div should be here, do not remove it! -->
            <template v-slot:block-link>
                <div @click="openModal()">
                    {{ $t("components.phones_edit.add_new_button") }}
                </div>
            </template>
        </ProfileBlock>

        <Modal
            :title="$t('components.phones_edit.modal.block_name')"
            ref="modal"
        >
            <FormulateForm
                id="add-new-phone-form"
                v-model="form"
                @submit="submit"
            >
                <FormulateInput
                    type="text"
                    name="number"
                    :label="$t('components.phones_edit.modal.number_label')"
                    validation="required|phone"
                />
                <FormulateInput
                    type="checkbox"
                    :label="$t('components.phones_edit.modal.primary_label')"
                    name="is_primary"
                />
            </FormulateForm>
            <template v-slot:actions>
                <button type="submit" form="add-new-phone-form">
                    {{ $t("components.phones_edit.modal.save_button") }}
                </button>
                <button @click="closeModal()" class="text-gray-400">
                    {{ $t("components.phones_edit.modal.cancel_button") }}
                </button>
            </template>
        </Modal>
    </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import Modal from "@/components/common/Modal";
import ProfileBlock from "@/components/profile/ProfileBlock";

export default {
    name: "PhonesEdit",
    data() {
        return {
            form: {}
        };
    },
    methods: {
        submit() {
            this.create(this.form).then(() => {
                this.$toast.success(
                    this.$t("components.phones_edit.created_message").toString()
                );
                this.closeModal();
            });
        },
        set_primary({ id }) {
            this.update({ id, is_primary: true }).then(() => {
                this.$toast.success(
                    this.$t(
                        "components.phones_edit.primary_updated_message"
                    ).toString()
                );
            });
        },
        destroy({ id }) {
            this.delete({ id }).then(() => {
                this.$toast.success(
                    this.$t("components.phones_edit.deleted_message").toString()
                );
            });
        },
        openModal() {
            this.$refs.modal.open();
        },
        closeModal() {
            this.form = {};
            this.$refs.modal.close();
        },
        ...mapActions({
            fetch: "profile/phones/fetch",
            create: "profile/phones/create",
            update: "profile/phones/update",
            delete: "profile/phones/delete"
        })
    },
    computed: {
        filtered_phones() {
            return this.phones.filter(phone => !phone.is_primary);
        },
        ...mapGetters({
            phones: "profile/phones/phones",
            primary: "profile/phones/primary"
        })
    },
    mounted() {
        this.fetch();
    },
    components: { Modal, ProfileBlock }
};
</script>

<style scoped></style>
